import { Palette } from '$setup/material-theme'

type NativeColor = string | 'default'

export function setNativeThemeColorImmediately(color: NativeColor) {
  return null
  // document
  //   .querySelector('meta[name="theme-color"]')
  //   ?.setAttribute('content', color === 'default' ? Palette.neutral100 : color)
}

export function setBottomSafeAreaColorImmediately(color: NativeColor) {
  return null

  // document.documentElement?.style.setProperty(
  //   '--safe-area-color',
  //   color === 'default' ? 'var(--safe-area-color__default)' : color,
  // )
}
